const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            cancel:             'Cancelar', back: 'Voltar',
            component:          'Estado do Ativo',
            component_new:      'Novo estado',
            component_edit:     'Editar estado',
            component_list:     'Lista de estados',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            color_primary:      'Cor Primária',
            color_secondary:    'Cor Secundária ',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao atualizar registo!',
            edit_success:       'Registo atualizado com sucesso!',
            field_activo:       'Ativo?',
            field_visivel:      'Visível?',
            field_avaiable:     'Disponível?',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:  'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:     'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait:      'Forfait',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_equipamento:      'Equipamento',
            field_equipamento_price:  'Preço do Equipamento',
            field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
            field_equipamento_taxe:  'IVA do Equipamento',
            field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
            field_final_price:  'Preço Final',
            field_final_price_palceholder: 'Introduza o Preço Final',
            field_price:        'Preço',
            field_price_since:  'Preço desde',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            field_duracao:      'Duração',
            field_person:       'Afetação de técnicos',
            field_appointment:  'Afetação de recursos',
            field_tag:         'Tag',
            field_tag_placeholder: 'Inserir a tag',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_color:        'Cores',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            save:               'Salvar',      
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n' ,
            youtube_choose:     'Youtube',     
            upload_file_error:  'O ficheiro tem mais de 10MB.',
                        
        },
    'en':
        {
            add_new:            'Add new',
            calendar:           'Calendar',
            cancel:             'Cancel', back: 'Voltar',
            component:          'Estado do Ativo',
            component_new:      'Novo estado',
            component_edit:     'Editar estado',
            component_list:     'Lista de estados',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            color_primary:      'Primary Color',
            color_secondary:    'Secondary Color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            field_activo:       'Ativo?',
            field_visivel:      'Visível?',
            field_avaiable:     'Disponível?',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:  'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:     'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait:      'Forfait',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_equipamento:      'Equipamento',
            field_equipamento_price:  'Preço do Equipamento',
            field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
            field_equipamento_taxe:  'IVA do Equipamento',
            field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
            field_final_price:  'Preço Final',
            field_final_price_palceholder: 'Introduza o Preço Final',
            field_price:        'Preço',
            field_price_since:  'Preço desde',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            field_duracao:      'Duração',
            field_person:       'Afetação de tecnicos',
            field_appointment:  'Afetação de recursos',
            field_tag:         'Tag',
            field_tag_placeholder: 'Inserir a tag',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_color:        'Cores',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            save:               'Save',
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n' ,
            youtube_choose:     'Youtube',     
            upload_file_error:  'O ficheiro tem mais de 10MB.',
            
        }
        ,
        'es':
        {
            add_new:            'Añadir nuevo',
cancel:             'Cancelar', back: 'Voltar',
component:          'Tipo de Documento',
component_new:      'Nuevo Tipo',
component_edit:     'Editar Tipo',
component_list:     'Lista de Tipos de Documento',
close:              'Cerrar',
color:              'Color',
color_placeholder:  'Introduzca el color',
color_primary:      'Color Primario',
color_secondary:    'Color Secundario',
delete:             'Eliminar',
delete_title:       'Eliminar Registro',
delete_text:        '¿Está seguro de que desea continuar?',
delete_confirm:     'Sí',
delete_cancel:      'No',
delete_error:       '¡Problema al eliminar el registro!',
delete_success:     '¡Registro eliminado con éxito!',
edit:               'Editar',
edit_title:         'Editar Registro',
edit_text:          '¿Está seguro de que desea continuar?',
edit_confirm:       'Sí',
edit_cancel:        'No',
edit_error:         '¡Problema al actualizar el registro!',
edit_success:       '¡Registro actualizado con éxito!',
field_activo:       '¿Activo?',
field_visivel:      '¿Visible?',
field_avaiable:     '¿Disponible?',
field_category:     'Categoría',
field_category_placeholder: 'Introduzca la categoría',
field_observation:  'Observación',
field_observation_placeholder: 'Introduzca una observación',
field_abreviation:  'Abreviatura',
field_abreviation_placeholder: 'Introduzca la abreviatura',
field_adultos:      'Adultos',
field_adultos_placeholder: 'Introduzca el número de adultos',
field_criancas:     'Niños',
field_criancas_placeholder: 'Introduzca el número de niños',
field_description:  'Descripción',
field_description_placeholder: 'Introduzca la descripción',
field_forfait:      'Forfait',
field_forfait_price:  'Precio del Forfait',
field_forfait_price_placeholder: 'Introduzca el precio del Forfait',
field_forfait_taxe:  'IVA del Forfait',
field_forfait_taxe_placeholder: 'Introduzca el IVA del Forfait',
field_equipamento:  'Equipamiento',
field_equipamento_price:  'Precio del Equipamiento',
field_equipamento_price_placeholder: 'Introduzca el precio del Equipamiento',
field_equipamento_taxe:  'IVA del Equipamiento',
field_equipamento_taxe_placeholder: 'Introduzca el IVA del Equipamiento',
field_final_price:  'Precio Final',
field_final_price_palceholder: 'Introduzca el Precio Final',
field_price:        'Precio',
field_price_since:  'Precio desde',
field_name:         'Nombre',
field_name_placeholder: 'Introduzca el nombre',
field_canhoes:      'Cañones de nieve',
field_status:       'Estado',
field_comprimento:  'Longitud',
field_comprimento_placeholder: 'Inserte longitud',
field_dificuldade:  'Dificultad',
field_dificuldade_placeholder: 'Inserte dificultad',
field_desnivel:     'Desnivel (m)',
field_desnivel_placeholder: 'Inserte desnivel (m)',
field_type:         'Tipo',
field_duracao:      'Duración',
field_person:       'Asignación de técnicos',
field_appointment:  'Asignación de recursos',
field_tag:          'Etiqueta',
field_tag_placeholder: 'Inserte la etiqueta',
filter_placeholder: 'Buscar',
id:                 'ID',
image:              'Imagen',
images:             'Imágenes',
image_choose:       'Elegir imagen',
insert_title:       'Nuevo Registro',
insert_text:        '¿Está seguro de que desea continuar?',
insert_confirm:     'Sí',
insert_cancel:      'No',
insert_error:       '¡Problema al insertar el registro!',
insert_success:     '¡Registro insertado con éxito!',
principal:          'Principal',
remove:             'Eliminar',
table_rows_per_page:'Registros por página:',
table_separator:    'de',
table_all:          'Todos',
table_title:        'Título',
table_parent:       'Parent',
table_date:         'Fecha',
table_color:        'Colores',
table_state:        'Estado',
table_actions:      'Acciones',
table_empty:        'sin resultados',
save:               'Guardar',
upload_image_error: 'Solo se permiten archivos jpg, jpeg y png.\nTamaño máximo: 10MB.\n\n',
youtube_choose:     'Youtube',
upload_file_error:  'El archivo supera los 10MB.',
        },
         'fr':
        {
            add_new:            'Ajouter nouveau',
cancel:             'Annuler',
component:          'Type de Document',
component_new:      'Nouveau Type',
component_edit:     'Modifier Type',
component_list:     'Liste des Types de Document',
close:              'Fermer',
color:              'Couleur',
color_placeholder:  'Entrez la couleur',
color_primary:      'Couleur Primaire',
color_secondary:    'Couleur Secondaire',
delete:             'Supprimer',
delete_title:       'Supprimer Enregistrement',
delete_text:        'Êtes-vous sûr de vouloir continuer ?',
delete_confirm:     'Oui',
delete_cancel:      'Non',
delete_error:       'Problème lors de la suppression de l\'enregistrement !',
delete_success:     'Enregistrement supprimé avec succès !',
edit:               'Modifier',
edit_title:         'Modifier Enregistrement',
edit_text:          'Êtes-vous sûr de vouloir continuer ?',
edit_confirm:       'Oui',
edit_cancel:        'Non',
edit_error:         'Problème lors de la mise à jour de l\'enregistrement !',
edit_success:       'Enregistrement mis à jour avec succès !',
field_activo:       'Actif ?',
field_visivel:      'Visible ?',
field_avaiable:     'Disponible ?',
field_category:     'Catégorie',
field_category_placeholder: 'Entrez la catégorie',
field_observation:  'Observation',
field_observation_placeholder: 'Entrez une observation',
field_abreviation:  'Abréviation',
field_abreviation_placeholder: 'Entrez l\'abréviation',
field_adultos:      'Adultes',
field_adultos_placeholder: 'Entrez le nombre d\'adultes',
field_criancas:     'Enfants',
field_criancas_placeholder: 'Entrez le nombre d\'enfants',
field_description:  'Description',
field_description_placeholder: 'Entrez la description',
field_forfait:      'Forfait',
field_forfait_price:  'Prix du Forfait',
field_forfait_price_placeholder: 'Entrez le prix du Forfait',
field_forfait_taxe:  'TVA du Forfait',
field_forfait_taxe_placeholder: 'Entrez la TVA du Forfait',
field_equipamento:  'Équipement',
field_equipamento_price:  'Prix de l\'Équipement',
field_equipamento_price_placeholder: 'Entrez le prix de l\'Équipement',
field_equipamento_taxe:  'TVA de l\'Équipement',
field_equipamento_taxe_placeholder: 'Entrez la TVA de l\'Équipement',
field_final_price:  'Prix Final',
field_final_price_palceholder: 'Entrez le Prix Final',
field_price:        'Prix',
field_price_since:  'Prix depuis',
field_name:         'Nom',
field_name_placeholder: 'Entrez le nom',
field_canhoes:      'Canons à neige',
field_status:       'État',
field_comprimento:  'Longueur',
field_comprimento_placeholder: 'Entrez la longueur',
field_dificuldade:  'Difficulté',
field_dificuldade_placeholder: 'Entrez la difficulté',
field_desnivel:     'Dénivelé (m)',
field_desnivel_placeholder: 'Entrez le dénivelé (m)',
field_type:         'Type',
field_duracao:      'Durée',
field_person:       'Affectation de techniciens',
field_appointment:  'Affectation de ressources',
field_tag:          'Étiquette',
field_tag_placeholder: 'Entrez l\'étiquette',
filter_placeholder: 'Rechercher',
id:                 'ID',
image:              'Image',
images:             'Images',
image_choose:       'Choisir une image',
insert_title:       'Nouvel Enregistrement',
insert_text:        'Êtes-vous sûr de vouloir continuer ?',
insert_confirm:     'Oui',
insert_cancel:      'Non',
insert_error:       'Problème lors de l\'insertion de l\'enregistrement !',
insert_success:     'Enregistrement inséré avec succès !',
principal:          'Principal',
remove:             'Supprimer',
table_rows_per_page:'Enregistrements par page :',
table_separator:    'de',
table_all:          'Tous',
table_title:        'Titre',
table_parent:       'Parent',
table_date:         'Date',
table_color:        'Couleurs',
table_state:        'État',
table_actions:      'Actions',
table_empty:        'aucun résultat',
save:               'Enregistrer',
upload_image_error: 'Seuls les fichiers jpg, jpeg et png sont autorisés.\nTaille maximale : 10MB.\n\n',
youtube_choose:     'Youtube',
upload_file_error:  'Le fichier dépasse 10MB.',
        }

}

module.exports = {
    language
};